import { useLocation } from "wouter";
import { useClient } from "@/contexts/ClientContext";

export const useClientNavigation = () => {
  const [, navigate] = useLocation();
  const { selectedClient } = useClient();

  const navigateWithClient = (path: string) => {
    if (selectedClient && !path.startsWith('/clients/')) {
      // If we have a selected client and the path doesn't already include client context
      const clientAwarePath = `/clients/${selectedClient.code}${path}`;
      navigate(clientAwarePath);
    } else if (selectedClient && path.startsWith('/clients/') && !path.includes(selectedClient.code)) {
      // If path has client context but for different client, update it
      const pathWithoutClient = path.replace(/^\/clients\/[^/]+/, '');
      const clientAwarePath = `/clients/${selectedClient.code}${pathWithoutClient}`;
      navigate(clientAwarePath);
    } else {
      // No client selected or path is already correct
      navigate(path);
    }
  };

  const getClientAwarePath = (path: string): string => {
    if (selectedClient && !path.startsWith('/clients/')) {
      return `/clients/${selectedClient.code}${path}`;
    } else if (selectedClient && path.startsWith('/clients/') && !path.includes(selectedClient.code)) {
      const pathWithoutClient = path.replace(/^\/clients\/[^/]+/, '');
      return `/clients/${selectedClient.code}${pathWithoutClient}`;
    }
    return path;
  };

  return {
    navigateWithClient,
    getClientAwarePath,
    selectedClient
  };
};